import React from 'react';
import { Customer } from '../../types/customer';
import { 
  UserIcon
} from '@heroicons/react/24/outline';

interface CustomerContactStatusProps {
  customer: Customer;
  onClick?: () => void;
}

const CustomerContactStatus: React.FC<CustomerContactStatusProps> = ({ customer, onClick }) => {
  // Count contact persons with different statuses
  const contactPersons = customer.contactPersons || [];
  const registeredCount = contactPersons.filter(cp => cp.hasUserAccount && cp.userId).length;
  const pendingCount = contactPersons.filter(cp => cp.invitationSentAt && !cp.userId).length;
  const totalCount = contactPersons.length;

  // Old system check
  const hasOldSystemAccount = customer.hasUserAccount && customer.userId;
  const hasOldSystemPending = customer.registrationToken && !customer.hasUserAccount;

  // If using new system (contactPersons array)
  if (totalCount > 0) {
    if (registeredCount === totalCount) {
      // All registered
      return (
        <button
          onClick={onClick}
          className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400"
          title={`${registeredCount}/${totalCount} kapcsolattartó regisztrált`}
        >
          <UserIcon className="h-4 w-4" />
        </button>
      );
    } else if (registeredCount > 0) {
      // Some registered, some not
      return (
        <button
          onClick={onClick}
          className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400"
          title={`${registeredCount}/${totalCount} regisztrált`}
        >
          <UserIcon className="h-4 w-4" />
        </button>
      );
    } else if (pendingCount > 0) {
      // Some pending
      return (
        <button
          onClick={onClick}
          className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400"
          title={`${pendingCount} meghívó függőben`}
        >
          <UserIcon className="h-4 w-4" />
        </button>
      );
    } else {
      // None registered, none pending
      return (
        <button
          onClick={onClick}
          className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400"
          title="Meghívó küldése"
        >
          <UserIcon className="h-4 w-4" />
        </button>
      );
    }
  }

  // Old system fallback
  if (hasOldSystemAccount) {
    return (
      <button
        onClick={onClick}
        className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400"
        title="Van fiókja"
      >
        <UserIcon className="h-4 w-4" />
      </button>
    );
  }

  if (hasOldSystemPending) {
    return (
      <button
        onClick={onClick}
        className="text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400"
        title="Meghívó függőben"
      >
        <UserIcon className="h-4 w-4" />
      </button>
    );
  }

  // No contacts, no old system account
  return (
    <button
      onClick={onClick}
      disabled
      className="text-gray-400 dark:text-gray-600 cursor-not-allowed opacity-50"
      title="Nincs kapcsolattartó - Adj hozzá kapcsolattartókat az ügyfél szerkesztése során"
    >
      <UserIcon className="h-4 w-4" />
    </button>
  );
};

export default CustomerContactStatus;
